import * as XLSX from 'xlsx';
import html2pdf from 'html2pdf.js';

export const exportToExcel = async (data, filename = 'export') => {
  if (!data || !data.length) {
    console.warn('No data provided for export');
    return;
  }
  
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, `${filename}.xlsx`);
};

export const exportToPDF = async (elements, filename = 'export.pdf') => {
  if (!elements) return;
  const elementsArray = Array.isArray(elements) ? elements : [elements];
  if (elementsArray.length === 0) return;
  
  const opt = {
    margin:       10,
    filename:     filename,
    image:        { type: 'jpeg', quality: 0.98 },
    html2canvas:  { scale: 2, useCORS: true, logging: false, windowWidth: 1400 },
    jsPDF:        { unit: 'mm', format: 'a3', orientation: 'landscape' },
    pagebreak:    { mode: ['css', 'legacy'], avoid: ['.bg-white', '.custom-shadow', '.overflow-hidden'] }
  };
  
  if (elementsArray.length === 1) {
    await html2pdf().set(opt).from(elementsArray[0]).save();
    return;
  }
  
  const container = document.createElement('div');
  container.style.width = '1400px';
  container.style.padding = '20px';
  container.style.backgroundColor = '#FAF8F5';
  
  elementsArray.forEach((el, index) => {
    if (el) {
      const clone = el.cloneNode(true);
      // Ensure all content is visible
      const elementsWithScroll = clone.querySelectorAll('*');
      elementsWithScroll.forEach(child => {
        child.style.overflow = 'visible';
      });
      
      const originalCanvases = el.querySelectorAll('canvas');
      const clonedCanvases = clone.querySelectorAll('canvas');
      originalCanvases.forEach((canvas, i) => {
        if (clonedCanvases[i]) {
          const img = document.createElement('img');
          img.src = canvas.toDataURL();
          img.style.width = canvas.style.width || canvas.width + 'px';
          img.style.height = canvas.style.height || canvas.height + 'px';
          img.className = clonedCanvases[i].className;
          clonedCanvases[i].parentNode.replaceChild(img, clonedCanvases[i]);
        }
      });
      
      if (index > 0) {
        const pageBreak = document.createElement('div');
        pageBreak.className = 'html2pdf__page-break';
        container.appendChild(pageBreak);
      }
      
      container.appendChild(clone);
    }
  });
  
  container.style.position = 'absolute';
  container.style.top = '0px';
  container.style.left = '0px';
  container.style.zIndex = '-9999';
  // Do NOT use opacity: 0 or display: none, as html2canvas will render it exactly like that (blank).
  document.body.appendChild(container);
  
  try {
    await html2pdf().set(opt).from(container).save();
  } finally {
    document.body.removeChild(container);
  }
};
